import { PulseBaseProvider } from '../../base-classes';

const _getMapFeatureDetailsCacheKey = 'getMapFeatureDetails';
const _getMapFeatureDetailUri = '/api/giv/featuredetails/v1/layerId={layerId}/slotId={slotId}/featureId={featureId}';

export class MapFeatureDetailsProvider extends PulseBaseProvider {

    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);
        this.storage.sync[_getMapFeatureDetailsCacheKey] = this.getMapFeatureDetailsSyncer.bind(this);
    }

    async getMapFeatureDetailsSyncer(params) {
        const {
            id,
            syncParams,
            resolve,
            reject,
        } = params;

        const queryParams = {
            ...syncParams.stdParameters,
            cultureInfo: syncParams.cultureInfo,
            temperatureUnit: syncParams.temperatureUnit,
            verbose: syncParams.verbose
        };

        return await super.syncData(
            syncParams.key
            , id
            , queryParams
            , _getMapFeatureDetailUri.replace('{layerId}', syncParams.layerId).replace('{slotId}', syncParams.slotId).replace('{featureId}', syncParams.featureId)
            , resolve
            , reject
            , null
            , syncParams.pulseApi
            , null
        );
    }

    async getMapFeatureDetails(layerId, slotId, featureId, temperatureUnit, cultureInfo, stdParameters, verbose = false, refresh = false) {
        const syncParams = {
            verbose: !!verbose,
            layerId,
            slotId,
            featureId,
            temperatureUnit,
            cultureInfo,
            refresh
        };

        const id = JSON.stringify(syncParams);
        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(_getMapFeatureDetailsCacheKey, id);
        }
        return await super.loadFromStorage(_getMapFeatureDetailsCacheKey, id, syncParams);
    }
}
